import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import ReactGA from 'react-ga4';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Chatbot from './components/Chatbot';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import Orcamento from './pages/Orcamento';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
  ReactGA.initialize(GA_MEASUREMENT_ID);
}

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [location]);
  return null;
}

function ChatbotWrapper() {
  const location = useLocation();
  // Hide chatbot in admin routes
  if (location.pathname.startsWith('/admin')) {
    return null;
  }
  return <Chatbot />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PageTracker />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/orcamento" element={<Orcamento />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard/*"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <ChatbotWrapper />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
